import { render, staticRenderFns } from "./CommentsView.vue?vue&type=template&id=75419af3&scoped=true&"
import script from "./CommentsView.vue?vue&type=script&lang=js&"
export * from "./CommentsView.vue?vue&type=script&lang=js&"
import style0 from "./CommentsView.vue?vue&type=style&index=0&id=75419af3&lang=scss&scoped=true&"
import style1 from "./CommentsView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75419af3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75419af3')) {
      api.createRecord('75419af3', component.options)
    } else {
      api.reload('75419af3', component.options)
    }
    module.hot.accept("./CommentsView.vue?vue&type=template&id=75419af3&scoped=true&", function () {
      api.rerender('75419af3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/CommentsView.vue"
export default component.exports